import { createSelector } from 'reselect'
import { startsWith, cloneDeep, groupBy, map, keys } from 'lodash';
import { maruti, oldsync } from './model'
import { textFilter, numberFilter } from '../../../utilities/listUtils'
import moment from 'moment';

export const getIsFetchingMaruti = (state, props) => state.txnsync.params.isFetching;
export const getIsMarutiFetched = (state, props) => state.txnsync.params.marutiFetched;
export const getMarutiList = (state, prop) => state.txnsync.byId
export const getMarutiCollection = (state, prop) => state.txnsync.collection
export const getIsSearching = (state, props) => state.txnsync.params.isSearching;
export const getIsSearchFetched = (state, props) => state.txnsync.params.searchFetched;
export const getSearchResults = (state, prop) => state.txnsync.searchResults
export const getOldSyncStatus = (state, prop) => state.txnsync.fetchedOldSyncStatus
export const filters = (state, prop) => state.txnsync.filterResults;
export const getNotificationPopup = (state, id) => state.txnsync.notificationsPopup;

export const getMaruti = (state, props) => {
    if (props.match.path === '/maruti/create') {
        return maruti()
    }
    if (props.match.path === '/maruti/edit/:id') {
        let id = props.match.params.id
        let obj = cloneDeep(state.txnsync.byId[id]);
        return obj
    }
}

export const getOldSyncData = (state, path) => {
    return oldsync()
}
export const getMarutiParams = (state, props) => {
    const params = {}

    if (startsWith(state.router.location.pathname, '/maruti/create')) {
        params.title = state.txnsync.params.createTitle
        params.submitButtonText = state.txnsync.params.createSubmitButtonText
    };

    if (startsWith(state.router.location.pathname, '/maruti/edit/')) {
        params.title = state.txnsync.params.editTitle
        params.submitButtonText = state.txnsync.params.editSubmitButtonText
    };

    return params
}

export const getSummary = createSelector(
    getMarutiCollection,
    coll => {
        // let coll = state.txnsync.collection
        let result = { "status": "", "count": 0 }
        if (coll.length > 0) {
            let group = groupBy(coll, 'status')
            result = map(keys(group), function (e) {
                return { "status": e, "count": group[e].length, "data": group[e] }
            })
        }
        console.log(result)
        return result
    })

export const selectMaruti = createSelector(
    getMarutiList,
    maruti => {
        const keys = Object.keys(maruti)
        const obj = keys.map((key) => { return { key: key, value: key, text: maruti[key].name } })
        return obj
    })


export const selectMarutiSearched = createSelector(
    getSearchResults,
    maruti => {
        const keys = Object.keys(maruti)
        const obj = keys.map((key) => { return { key: key, value: key, text: maruti[key].name } })
        return obj
    })

// "All" must show EVERYTHING, so it is built from the raw `collection` (which
// keeps every record, incl. all parked rows that collapse in `byId`). postStatus
// is overlaid from `byId` so the error "Reposted" indicator still works.
export const getFilteredMarutiList = createSelector(
    getMarutiCollection, getMarutiList,
    (collection, byId) => {
        let list = (collection || []).map(function (item) {
            const stored = item.redisId ? byId[item.redisId] : undefined
            return stored && stored.postStatus !== undefined
                ? { ...item, postStatus: stored.postStatus }
                : item
        })
        let sortedData = list.sort((a, b) => { return moment(b.TRANS_DATE) - moment(a.TRANS_DATE) })
        return sortedData
    })

export const getFilteredMarutiSuccessList = createSelector(
    getMarutiList,
    (ledgermap,) => {
        let filteredTxnsync = Object.keys(ledgermap).map(function (key) {
            return ledgermap[key];
        })
        let successArray = filteredTxnsync.filter((item) => item.type === ("success" || "Success"))
        // console.log(successArray, '--------succcces arry')
        let sortedData = successArray.sort((a, b) => { return moment(b.TRANS_DATE) - moment(a.TRANS_DATE) })
        return sortedData
    })

export const getFilteredMarutiInProcessList = createSelector(
    getMarutiList,
    (list) => {
        let filteredTxnSync = Object.keys(list).map(function (key) {
            return list[key]
        })
        let inProcessArray = filteredTxnSync.filter((item) => item.type === "in-process")
        let sortedData = inProcessArray.sort((a, b) => { return moment(b.TRANS_DATE) - moment(a.TRANS_DATE) })
        return sortedData
    }
)

export const getFilteredMarutiErrorList = createSelector(
    getMarutiList,
    (ledgermap,) => {
        let filteredTxnsync = Object.keys(ledgermap).map(function (key) {
            return ledgermap[key];
        })
        let errorArray = filteredTxnsync.filter((item) => item.type === ("error" || "Error"))
        let sortedData = errorArray.sort((a, b) => { return moment(b.TRANS_DATE) - moment(a.TRANS_DATE) })
        return sortedData
    })

export const getFilteredMarutiExceptionList = createSelector(
    getMarutiList,
    (ledgermap,) => {
        let filteredTxnsync = Object.keys(ledgermap).map(function (key) {
            return ledgermap[key];
        })
        let exceptionArray = filteredTxnsync.filter((item) => item.type === ("exception" || "Exception"))
        let sortedData = exceptionArray.sort((a, b) => { return moment(b.TRANS_DATE) - moment(a.TRANS_DATE) })
        return sortedData
    })

export const getFilteredMarutiParkedList = createSelector(
    getMarutiCollection,
    (ledgermap,) => {
        let filteredTxnsync = Object.keys(ledgermap).map(function (key) {
            return ledgermap[key];
        })
        let parkedArray = filteredTxnsync.filter((item) => item.type === ("parked" || "Parked"))
        let sortedData = parkedArray.sort((a, b) => { return moment(b.TRANS_DATE) - moment(a.TRANS_DATE) })
        return sortedData
    })
